import { Component, Vue } from 'vue-property-decorator';
import PageText from '@/components/page/text/Text.vue';

@Component({
  components: { PageText },
  metaInfo() {
    const { description, keywords, title } = this as PageSmartInfo;
    return { description, keywords, title };
  },
})
export default class PageSmartInfo extends Vue {
  // Readonly
  content: string = '';
  description: string = '';
  keywords: string = '';
  title: string = 'Умный навигатор';
}



// WEBPACK FOOTER //
// ./src/pages/smart/info/script.ts